module.exports = __webpack_public_path__ + "imgs/topical.e6510e9c1ff1f86d72c360f3aa95bc9d.jpg";